
export default (currentValue=0, monthlyBudget=0, days,GetNoOfHolidaysbyDate,GetNoOfHolidaysbyMonth,day) => {
    let trend=0;
    if(currentValue!==0 && monthlyBudget!==0){
         trend = (((currentValue - ((monthlyBudget * (day-GetNoOfHolidaysbyDate)) / (days-GetNoOfHolidaysbyMonth))) / monthlyBudget) * 100).toFixed(1)
    }
   
    return trend;
}